module.exports = __webpack_public_path__ + "static/carsBg-0142faebecaa2e9c0f52c126e327fa3f.jpg";